.example-form{min-width:150px;max-width:500px;width:100%}.example-full-width{width:100%}
/*# sourceMappingURL=search.component-FPWXQECK.css.map */
